import { FC } from 'react';

import { FormMarkdown } from '../../Form.styled';
import { ErrorMessage } from './ErrorMessage';

interface FormInputDetailsProps {
  dataKey: string;
  description?: string;
  errorMessages?: string[];
  groupKey?: string;
}

export const FormInputDetails: FC<FormInputDetailsProps> = ({
  dataKey,
  description,
  errorMessages,
  groupKey = '',
}) => {
  return (
    <>
      {description && <FormMarkdown>{description}</FormMarkdown>}
      {errorMessages?.map((errorMessage, index) => (
        <ErrorMessage
          id={`${groupKey}-${dataKey}-error-message-${index}`}
          key={`${groupKey}-${dataKey}-error-message-${index}`}
        >
          {errorMessage}
        </ErrorMessage>
      ))}
    </>
  );
};
